//Use CommonJS style via browserify to load other modules
require("component-responsive-frame/child");

var qsa = function(s) { return Array.prototype.slice.call(document.querySelectorAll(s)) };

var blocks = qsa(".row .block");

var makeEvent = function(type) {
  if (typeof window.CustomEvent == "function") return new CustomEvent(type);
  var event = document.createEvent("CustomEvent");
  event.initEvent(type, true, true);
  return event;
}

var slideTime = 400;

var slideUp = function(row) {
  row.classList.remove("show");
  row.classList.add("slide");
  row.style.height = "0px";
  setTimeout(() => row.classList.remove("slide"), slideTime);
}

var slideDown = function(row) {
  row.style.height = "auto";
  var { height } = row.getBoundingClientRect();
  if (!row.classList.contains("show")) {
    row.style.height = "0px";
    row.classList.add("slide");
    setTimeout(function() { 
      row.classList.remove("slide");
      row.style.height = "auto";
    }, slideTime);
    var _ = row.offsetHeight;
  }
  row.style.height = height + "px";
  row.classList.add("show");
}

var onClick = function(e) {
  var attr = this.getAttribute("data-block");
  if (!attr) return;
  var [row, block] = attr.split("-");
  var row = document.querySelector(`.details[data-row="${row}"]`);
  var block = row.querySelector(`.caption[data-block="${block}"]`);

  //hide existing blocks
  var previousRow = document.querySelector(".details.show");
  if (previousRow && row !== previousRow) slideUp(previousRow);
  var previousBlock = document.querySelector(".caption.selected");
  if (previousBlock) previousBlock.classList.remove("selected");
  var previousImage = document.querySelector(".block.selected");
  if (previousImage) previousImage.classList.remove("selected");

  //show new blocks
  this.classList.add("selected");
  block.classList.add("selected");

  //find the current position
  var offset = this.offsetLeft * 1 + this.offsetWidth * .5;
  var triangle = row.querySelector(".triangle");
  offset -= triangle.getBoundingClientRect().width * .5;
  triangle.style.left = offset + "px";

  // if (row.classList.contains("show")) return;

  //check to see if the image is loaded
  var img = block.querySelector("img");
  if (img.naturalHeight == 0) {
    img.onload = slideDown.bind(null, row);
  } else {
    //otherwise slide down now
    slideDown(row);
  }

};

blocks.forEach(block => block.addEventListener("click", onClick));

blocks[0].dispatchEvent(makeEvent("click"));

//delegate listener for the arrows
document.body.addEventListener("click", function(e) {
  var target = e.target;
  if (!e.target.classList.contains("shift")) return;
  var selected = document.body.querySelector(".block.selected");
  if (!selected) return;
  var next = selected[e.target.classList.contains("previous") ? "previousElementSibling" : "nextElementSibling"];
  if (!next) return;
  next.dispatchEvent(makeEvent("click"));
});